import { combineEpics } from 'redux-observable';
// ---- external imports ----

import errorHandlingEpic from './errorHandlingEpic';
import { saveFinancialStatementsEpic } from './saveFinancialStatementsEpic';
// ---- local imports ----

export default combineEpics(
	errorHandlingEpic,
	saveFinancialStatementsEpic,
);
